module.exports = __webpack_public_path__ + "img/cleaning-blue2.05961d7d.svg";